export const userRoles = {
  Admin: "Admin",
  Production_Coordinator: "Production_Coordinator",
  Quality_Controller_Coordinator: "QC_Coordinator",
  Quality_Controller_Inspector: "QC_Inspector",
  Document_Controller: "Document_Controller",
  Product_Engineer: "Product_Engineer",
  Quality_Controller_Manager: "QC_Manager",
};

export const listOfDocuments = [
  "work_order",
  "purchase_order",
  "ga_drawing",
  "master_prod_schedule",
  "job_history_sheet",
  "inspector_test_plan",
  "mill_certificate",
  "technical_query",
  "wps_pqr_list",
  "welder_register",
  "weld_map_ndt_map",
  "ndt_reports",
  "others",
];

export const dimensionalStage = {
  stage_1: 1,
  stage_2: 2,
  stage_3: 3,
  stage_4: 4,
  stage_5: 5,
  stage_6: 6,
  stage_7: 7,
};

export const notificationType = {
  uploadDocForRFI: "uploadDocForRFI",
  docUploaded: "docUploaded",
};

// Table columns config
export const RFItableColumns = [
  {
    id: "rfi_id",
    label: "RFI No",
    fieldType: "text",
    fontWeight: "bold",
    cellSize: "normal",
    sortable: true,
  },
  {
    id: "kd_number",
    label: "KD No",
    fieldType: "text",
    cellSize: "medium",
    sortable: false,
  },
  {
    id: "wo_number",
    label: "WO No",
    fieldType: "text",
    cellSize: "medium",
    sortable: false,
  },
  {
    id: "customer_name",
    label: "Customer",
    fieldType: "text",
    cellSize: "medium",
    sortable: false,
  },
  {
    id: "assign_template",
    label: "Assign Template",
    fieldType: "action",
    fontWeight: "bold",
    cellSize: "xlarge",
    sortable: false,
  },
  {
    id: "build_workshop",
    label: "Build Workshop",
    fieldType: "text",
    cellSize: "medium",
    sortable: false,
  },
  // { id: "poNumber", label: "PO No", fieldType: "text" },
  {
    id: "project_title",
    label: "Title",
    fieldType: "text",
    cellSize: "xlarge",
    sortable: true,
  },
  {
    id: "creation_date",
    label: "Created At",
    fieldType: "date",
    cellSize: "normal",
    sortable: true,
  },
  {
    id: "asset_type",
    label: "Type",
    fieldType: "text",
    cellSize: "normal",
    sortable: false,
  },
  {
    id: "status",
    label: "RFI Status",
    fieldType: "progress_badge",
    cellSize: "normal",
    sortable: false,
  },
  {
    id: "purpose_type",
    label: "Purpose",
    fieldType: "text",
    cellSize: "normal",
    sortable: false,
  },
  {
    id: "pc_name",
    label: "PC Name",
    fieldType: "text",
    cellSize: "normal",
    sortable: true,
  },
  {
    id: "elapsed_days",
    label: "Elapsed Days",
    fieldType: "elapsedDays",
    cellSize: "normal",
    sortable: true,
  },
  {
    id: "documents_status",
    label: "Doc Status",
    fieldType: "status_badge",
    cellSize: "large",
    sortable: false,
  },
  {
    id: "dimensional_stage",
    label: "Dimensional Stage",
    fieldType: "status_badge",
    cellSize: "normal",
    sortable: false,
  },
  {
    id: "qc_name",
    label: "Inspector Name",
    fieldType: "text",
    cellSize: "normal",
    sortable: true,
  },
];

export const RFItableFilters = [
  {
    id: "rfi_id",
    label: "RFI No",
    filterType: "searchSelect",
  },
  {
    id: "kd_number",
    label: "KD No",
    filterType: "searchSelect",
  },
  {
    id: "wo_number",
    label: "WO No",
    filterType: "searchSelect",
  },
  {
    id: "build_workshop",
    label: "Build Workshop",
    filterType: "searchSelect",
  },
  // {
  //   id: "project_title",
  //   label: "Title",
  //   filterType: "searchSelect",
  // },
  // {
  //   id: "creation_date",
  //   label: "Created At",
  //   filterType: "date",
  // },
  {
    id: "asset_type",
    label: "Type",
    filterType: "searchSelect",
  },
  {
    id: "status",
    label: "RFI Status",
    filterType: "searchSelect",
  },
  {
    id: "purpose_name",
    label: "Purpose",
    filterType: "searchSelect",
  },
  {
    id: "customer_name",
    label: "Customer",
    filterType: "searchSelect",
  },
  {
    id: "production_coordinator_name",
    label: "PC Name",
    filterType: "searchSelect",
  },
  {
    id: "start_date",
    label: "Start Date",
    filterType: "date",
  },
  {
    id: "end_date",
    label: "End Date",
    filterType: "date",
  },
  {
    id: "documents_status",
    label: "Doc Status",
    filterType: "searchSelect",
  },
  {
    id: "dimensional_stage",
    label: "Dimensional Stage",
    filterType: "searchSelect",
  },
  {
    id: "qc_inspector_name",
    label: "QC Name",
    filterType: "searchSelect",
  },
  {
    id: "model_name",
    label: "Model Name",
    filterType: "searchSelect",
  },
];

export const documentStatus = {
  All_Uploaded: "All_Uploaded",
  Partially_Uploaded: "Partially_Uploaded",
  Awaiting_Documents: "Awaiting_Documents",
  Upload_Completed: "Upload_Completed",
  Awaiting_E_Signature: "Awaiting_E_Signature",
  All_Signed: "All_Signed",
};

export const purposeList = {
  fitUp: "Fit Up",
  repair: "Repair",
  dimensional: "Dimensional",
  welding: "Welding",
  ndt: "NDT",
  finalInspection: "Final Inspection",
  visual: "Visual",
  lineBoring: "Line Boring",
  other: "Other",
};

export const modals = [
  { model_name: "Model 1", model_id: 1 },
  { model_name: "Model 2", model_id: 2 },
  { model_name: "Model 3", model_id: 3 },
];

export const createRfiNdtReportColumn = [
  { id: "jointNo", label: "JOINT NO.", type: "number", disabled: true },
  {
    id: "description",
    label: "DESCRIPTION",
    type: "text",
    disabled: false,
  },
];

export const ndtReportColumn = [
  { id: "jointNo", label: "JOINT NO.", type: "number", disabled: true },
  {
    id: "description",
    label: "DESCRIPTION",
    type: "text",
    disabled: false,
  },
  {
    id: "mtPtDate",
    label: "DATE",
    type: "text",
    disabled: true,
    section: "MT/PT",
  },
  {
    id: "mtPtReportNo",
    label: "REPORT NO",
    type: "text",
    disabled: true,
    section: "MT/PT",
  },
  {
    id: "mtPtResult",
    label: "RESULT",
    type: "text",
    disabled: true,
    section: "MT/PT",
  },
  {
    id: "utDate",
    label: "DATE",
    type: "text",
    disabled: true,
    section: "UT",
  },
  {
    id: "utReportNo",
    label: "REPORT NO",
    type: "text",
    disabled: true,
    section: "UT",
  },
  {
    id: "utResult",
    label: "RESULT",
    type: "text",
    disabled: true,
    section: "UT",
  },
  {
    id: "consumableType",
    label: "TYPE",
    type: "text",
    disabled: true,
    section: "CONSUMABLE",
  },
  {
    id: "consumableWireCert",
    label: "WIRE CERT",
    type: "text",
    disabled: true,
    section: "CONSUMABLE",
  },
  { id: "remarks", label: "REMARKS", type: "text", disabled: true },
];

export const ndtMapColumn = [
  { id: "thickness_1", label: "Thik 1", type: "number" },
  { id: "thickness_2", label: "Thik 2", type: "number" },
  { id: "length", label: "Lgt", type: "number" },
  { id: "material", label: "Mtl", type: "number" },
  { id: "astm_qt", label: "ASTM/Q&T", type: "string" },
  { id: "ut_mt", label: "UT & MT", type: "string" },
];

// Column configuration - simplified without validation and editable properties
export const additionsColumn = [
  {
    id: "picture",
    label: "Picture",
    type: "image",
    width: "120px",
    required: false,
  },
  {
    id: "pin",
    label: "PIN",
    type: "number",
    width: "120px",
    required: true,
  },
  {
    id: "part_description",
    label: "Part Description",
    type: "text",
    width: "200px",
    required: true,
  },
  {
    id: "length",
    label: "Length",
    type: "number",
    width: "120px",
    required: true,
  },
  {
    id: "width",
    label: "Width",
    type: "number",
    width: "120px",
    required: true,
  },
  {
    id: "quantity",
    label: "Quantity",
    type: "number",
    width: "120px",
    required: true,
  },
  {
    id: "part_type",
    label: "Part Type",
    type: "text",
    width: "160px",
    required: true,
  },
  {
    id: "remarks",
    label: "Remarks",
    type: "text",
    width: "200px",
    required: true,
    showCondition: (showInspectorFields) => showInspectorFields,
  },
  {
    id: "qc_verify",
    label: "QC Verify",
    type: "checkbox",
    width: "100px",
    required: false,
    showCondition: (showInspectorFields) => showInspectorFields,
  },
  {
    id: "actions",
    label: "",
    type: "actions",
    width: "120px",
    required: false,
  },
];

export const actionType = {
  rfi_create: "rfi_create",
  template_create: "template_create",
  template_view: "template_view",
  template_delete: "template_delete",
  template_edit: "template_edit",
  rfi_view: "rfi_view",
  stage_view: "stage_view",
  stage_edit: "stage_edit",
  stage_skip: "stage_skip",
  stage_approve: "stage_approve",
  stage_reject: "stage_reject",
  activity_log_view: "activity_log_view",
  documents_view: "documents_view",
  documents_upload: "documents_upload",
  documents_delete: "documents_delete",
  documents_require_signature: "documents_require_signature",
  documents_mark_completed: "documents_mark_completed",
  documents_sign: "documents_sign",
  component_create: "component_add",
  component_delete: "component_delete",
  component_edit: "component_edit",
};
